// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import i18n from './i18n';
import store from './store';

// 通用样式
import './global/common.css';

// 公用组件
import dmHeader from './components/dm-header.vue';
import selectCombobox from './components/select/combobox.vue';
Vue.config.productionTip = false;
Vue.component('dm-header', dmHeader);
Vue.component('select-combobox', selectCombobox);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js